import { LoadingButton } from '@mui/lab';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    TextField,
} from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { designAPI } from '@api/designs';
import { useStyles } from '../styles/DialogStyles.styles';

import type { Manufacturer } from '@features/redux/slices/designSlice';
import type { RootState } from '@features/redux/store';

interface ManufacturerEditDialogProps {
    manufacturer?: Manufacturer;
    cancel: (updated: boolean) => void;
}

export const ManufacturerEditDialog = ({ manufacturer, cancel }: ManufacturerEditDialogProps) => {
    const styles = useStyles();

    const { IdToken } = useSelector((state: RootState) => state.auth);

    const { postManufacturer } = designAPI(IdToken as string);

    const defaultName = manufacturer ? manufacturer.manufacturerName : '';
    const defaultActive = manufacturer ? manufacturer.active : true;

    const [name, setName] = useState(defaultName);

    const [active, setActive] = useState(defaultActive);

    const [loading, setLoading] = useState(false);

    const validateFormData = () => {
        return Boolean(name);
    };

    const saveManufacturer = async () => {
        if (!validateFormData()) {
            alert('Fill in all data!');
            return;
        }

        setLoading(true);

        const item = {
            manufacturerName: name,
            icon: 'none',
            active,
        };

        const itemFilled: Partial<Manufacturer> = manufacturer
            ? { manufacturerId: manufacturer.manufacturerId, ...item }
            : item;

        try {
            await postManufacturer(itemFilled);
            cancel(true);
        } catch (error) {
            setLoading(false);
            alert('Error occured while uploading data!');
        }
    };

    return (
        <Dialog open={true} fullWidth maxWidth={'md'}>
            <DialogTitle className={styles.dialogTitle}>
                {manufacturer ? 'Edit Manufacturer' : 'Add Manufacturer'}
            </DialogTitle>

            <DialogContent className={styles.dialogContent}>
                <TextField
                    label='Name'
                    className={styles.textField}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />

                <FormGroup className={styles.checkboxContainer}>
                    <FormControlLabel
                        control={<Checkbox checked={active} onChange={(e) => setActive(e.target.checked)} />}
                        label={'active'}
                    />
                </FormGroup>
            </DialogContent>

            <DialogActions className={styles.dialogActions}>
                <LoadingButton
                    loading={loading}
                    variant={'contained'}
                    className={styles.save}
                    onClick={saveManufacturer}>
                    Save
                </LoadingButton>
                <Button disabled={loading} onClick={() => cancel(false)}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
